import { render, staticRenderFns } from "./CmsCarouselWithImage.vue?vue&type=template&id=d4095c0a"
import script from "./CmsCarouselWithImage.vue?vue&type=script&lang=ts"
export * from "./CmsCarouselWithImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports